<template>
    <div >
        <div class="form-group">
            <input type="email" name="username" v-model="formParams.username" placeholder="введите email..." class="form-control"  >
        </div>
        <div class="form-group">
            <input type="password" name="password" v-model="formParams.password" placeholder="введите пароль..." class="form-control" >
        </div>
        <div class="form-group">
            <a href="/remember-password-form">Забыли пароль?</a>
        </div>
        <button class="btn btn-warning btn-custom" @click="auth">Войти</button>
        <p class="spacer">&nbsp;</p>
        <p class="spacer">&nbsp;</p>
        <p class="spacer">&nbsp;</p>
    </div>
</template>

<script>
    export default {
        name: "LoginForm",
        data() {
            return {
                formParams: {}
            }
        },
        methods: {
            auth() {
                this.$http.post('/login', this.formParams).then( response => {
                    const userData = response.data
                    if(userData.username){
                        window.location.href = '/customer/private/bio';
                    }else{
                        this.$modal.show('dialog', {
                            title: 'Ошибка авторизации',
                            text: 'Неверный логин или пароль.',
                            buttons: [
                                {
                                    title: 'Закрыть'
                                }
                            ]
                        })
                    }
                }, error => {
                    error
                    this.$modal.show('dialog', {
                        title: 'Ошибка авторизации',
                        text: 'Неверный логин или пароль.',
                        buttons: [
                            {
                                title: 'Закрыть'
                            }
                        ]
                    })
                })
            }

        }
    }
</script>

<style scoped>

</style>